module.exports = __webpack_public_path__ + "./eric_a76a574f0f9f06d644d20faaf94380b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2014/eric.png
// module id = 413
// module chunks = 0